import {
  styled,
  Box,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@mui/material';
import { WarningCircle } from '@phosphor-icons/react';

export const DialogTitleStyled = styled(DialogTitle)(({ theme }) => ({
  ...theme.typography.body1,
  alignItems: 'center',
  display: 'flex',
  fontWeight: 600,
  gap: 6,
  padding: theme.spacing(5, 5, 2),
}));

export const DialogContentStyled = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(0, 5, 5),
}));

export const DialogContentTextStyled = styled(DialogContentText)(
  ({ theme }) => ({
    ...theme.typography.body2,
    color: theme.palette.primaryDark.main,
  })
);

export const ActionButtonsWrapperStyled = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const DialogActionsStyled = styled(DialogActions)(({ theme }) => ({
  flexWrap: 'wrap',
  padding: theme.spacing(0, 5, 5),
}));

export const WarningIconStyled = styled(WarningCircle)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: '2.5rem',
}));
